import React, { useEffect, useState } from 'react';
import { Descriptions } from 'antd';
import { useIntl } from 'react-intl';

import { getParcelMetrics } from 'services/business';
import { ACL_MATRIX } from 'common/permissions';
import { isUserAuthorized } from 'utils/helpers';

import { notify } from 'components/Notify/Notify';
import LoadingWrapper from 'components/LoadingWrapper/LoadingWrapper';

import './ParcelMetrics.less';

const ParcelMetrics = ({ businessId, dateValue, ...props }) => {
  const { formatMessage } = useIntl();
  const { Item } = Descriptions;

  const [parcelMetricsData, setParcelMetricsData] = useState({});
  const [isParcelMetricsLoading, setIsParcelMetricsLoading] = useState(false);

  useEffect(() => {
    if (!dateValue || !businessId) {
      setParcelMetricsData({});
      return;
    }

    const fetchParcelMetrics = async () => {
      try {
        setIsParcelMetricsLoading(true);
        const queryParams = {
          businessId,
          date: dateValue?.format('YYYY-MM-DD')
        };
        const { data } = await getParcelMetrics({ ...queryParams });

        setParcelMetricsData(data);
      } catch (error) {
        notify(error);
      } finally {
        setIsParcelMetricsLoading(false);
      }
    };

    if (
      isUserAuthorized(
        [],
        [ACL_MATRIX.BUSINESS_ANALYTICS_GET_PARCEL_QUALITY_METRICS]
      )
    ) {
      fetchParcelMetrics();
    }
  }, [dateValue, businessId]);

  return (
    <LoadingWrapper loading={isParcelMetricsLoading}>
      <Descriptions className="br-parcel-metrics" column={3} bordered={true}>
        <Item span={1}>
          <div className="br-parcel-metrics__item">
            <span className="br-parcel-metrics__label">
              {formatMessage({
                id: 'merchant_analysis.parcel_metrics.green_orders'
              })}
            </span>
            <span className="br-parcel-metrics__value">
              {formatMessage(
                { id: 'common.percentage' },
                { value: parcelMetricsData?.greenPercentage }
              )}
            </span>
          </div>
        </Item>

        <Item span={1}>
          <div className="br-parcel-metrics__item">
            <span className="br-parcel-metrics__label">
              {formatMessage({
                id: 'merchant_analysis.parcel_metrics.grey_orders'
              })}
            </span>
            <span className="br-parcel-metrics__value ">
              {formatMessage(
                { id: 'common.percentage' },
                { value: parcelMetricsData?.greyPercentage }
              )}
            </span>
          </div>
        </Item>

        <Item span={1}>
          <div className="br-parcel-metrics__item">
            <span className="br-parcel-metrics__label">
              {formatMessage({
                id: 'merchant_analysis.parcel_metrics.black_orders'
              })}
            </span>
            <span className="br-parcel-metrics__value black-orders-value">
              {formatMessage(
                { id: 'common.percentage' },
                { value: parcelMetricsData?.blackPercentage }
              )}
            </span>
          </div>
        </Item>
      </Descriptions>
    </LoadingWrapper>
  );
};

export default ParcelMetrics;
